module.exports = __webpack_public_path__ + "img/2.8b4eb8f4.png";